import { useState, useEffect } from "react";

export default function useStaleCopy(obj: Record<string, JsonValue>) {
  const [copy, setCopy] = useState<Record<string, JsonValue>>({});

  useEffect(() => {
    setCopy(obj);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return copy;
}
